import { render, staticRenderFns } from "./BlockNavigation.vue?vue&type=template&id=00ce6571&"
import script from "./BlockNavigation.vue?vue&type=script&lang=js&"
export * from "./BlockNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BlockNavigation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports